import React from "react";

export const MedicIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.70833 7.79256C7.70833 6.52691 8.73435 5.50089 10 5.50089C11.2657 5.50089 12.2917 6.52691 12.2917 7.79256C12.2917 9.05821 11.2657 10.0842 10 10.0842C8.73435 10.0842 7.70833 9.05821 7.70833 7.79256ZM10 6.75089C9.4247 6.75089 8.95833 7.21726 8.95833 7.79256C8.95833 8.36786 9.4247 8.83423 10 8.83423C10.5753 8.83423 11.0417 8.36786 11.0417 7.79256C11.0417 7.21726 10.5753 6.75089 10 6.75089Z"
        fill="CurrentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 10.5009C9.00354 10.5009 8.07051 10.7015 7.36347 11.055C6.69381 11.3899 6.04167 11.9681 6.04167 12.7926L6.04156 12.8446C6.04028 13.2699 6.03813 13.986 6.71686 14.4774C7.03182 14.7053 7.44741 14.8507 7.96224 14.9434C8.48184 15.0369 9.14768 15.0842 10 15.0842C10.8523 15.0842 11.5182 15.0369 12.0378 14.9434C12.5526 14.8507 12.9682 14.7053 13.2831 14.4774C13.9619 13.986 13.9597 13.2699 13.9584 12.8446L13.9583 12.7926C13.9583 11.9681 13.3062 11.3899 12.6365 11.055C11.9295 10.7015 10.9965 10.5009 10 10.5009ZM7.29167 12.7926C7.29167 12.6966 7.38571 12.4415 7.92249 12.1731C8.42188 11.9234 9.15551 11.7509 10 11.7509C10.8445 11.7509 11.5781 11.9234 12.0775 12.1731C12.6143 12.4415 12.7083 12.6966 12.7083 12.7926C12.7083 13.2963 12.6763 13.3735 12.5502 13.4648C12.4485 13.5384 12.2391 13.6371 11.8164 13.7131C11.3985 13.7883 10.8143 13.8342 10 13.8342C9.18566 13.8342 8.6015 13.7883 8.18359 13.7131C7.76092 13.6371 7.55151 13.5384 7.44981 13.4648C7.32374 13.3735 7.29167 13.2963 7.29167 12.7926Z"
        fill="CurrentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.26949 2.00182C8.47277 1.58971 9.21873 1.33423 10 1.33423C10.7813 1.33423 11.5272 1.58971 12.7305 2.00183L13.3367 2.20934C14.5711 2.63189 15.5238 2.958 16.2058 3.23505C16.5493 3.37461 16.8447 3.50979 17.0825 3.6479C17.3114 3.78081 17.541 3.94659 17.697 4.16885C17.8512 4.38853 17.9309 4.6586 17.981 4.91858C18.0331 5.18886 18.0645 5.51309 18.0847 5.88536C18.125 6.62456 18.125 7.63723 18.125 8.95074V10.2854C18.125 15.3696 14.285 17.8072 12.0014 18.8047L11.9788 18.8146C11.6956 18.9383 11.4295 19.0546 11.1237 19.1329C10.8008 19.2155 10.4577 19.2509 10 19.2509C9.54228 19.2509 9.19922 19.2155 8.87634 19.1329C8.57051 19.0546 8.30436 18.9383 8.02119 18.8146L7.99861 18.8047C5.71502 17.8072 1.875 15.3696 1.875 10.2854V8.95081C1.875 7.63738 1.875 6.62453 1.91525 5.88536C1.93552 5.51309 1.96693 5.18886 2.01901 4.91858C2.06911 4.6586 2.14884 4.38853 2.30303 4.16885C2.45902 3.94659 2.68862 3.78081 2.91748 3.6479C3.15531 3.50979 3.45065 3.37461 3.79419 3.23505C4.47617 2.958 5.42885 2.63189 6.66329 2.20934L7.26949 2.00182ZM10 2.58423C9.45188 2.58423 8.91262 2.76059 7.56718 3.22114L7.08984 3.38454C5.82934 3.81601 4.91008 4.13093 4.26466 4.39313C3.9425 4.52401 3.70908 4.63368 3.54524 4.72884C3.46435 4.77581 3.40861 4.81458 3.37139 4.84483C3.33983 4.87049 3.3278 4.88502 3.32608 4.88713C3.32446 4.88975 3.31411 4.90706 3.29952 4.94801C3.28287 4.99477 3.26441 5.0618 3.24643 5.15511C3.21003 5.34397 3.18245 5.60341 3.1634 5.95333C3.12523 6.65432 3.125 7.63284 3.125 8.97311V10.2854C3.125 14.5979 6.34991 16.7204 8.49899 17.6592C8.80856 17.7944 8.98732 17.871 9.18633 17.9219C9.3764 17.9706 9.60833 18.0009 10 18.0009C10.3917 18.0009 10.6236 17.9706 10.8137 17.9219C11.0127 17.871 11.1914 17.7944 11.501 17.6592C13.6501 16.7204 16.875 14.5979 16.875 10.2854V8.97311C16.875 7.63284 16.8748 6.65432 16.8366 5.95333C16.8175 5.60341 16.79 5.34397 16.7536 5.15511C16.7356 5.0618 16.7171 4.99477 16.7005 4.94801C16.6859 4.90703 16.6755 4.88973 16.6739 4.88713C16.6722 4.88499 16.6601 4.87047 16.6286 4.84483C16.5914 4.81458 16.5356 4.77581 16.4548 4.72884C16.2909 4.63368 16.0575 4.52401 15.7353 4.39313C15.0899 4.13093 14.1707 3.81601 12.9102 3.38454L12.4328 3.22114C11.0874 2.76059 10.5481 2.58423 10 2.58423Z"
        fill="CurrentColor"
      />
    </svg>
  );
};

export const HospitalIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 8.97311C2.5 6.30845 2.5 4.97613 2.8146 4.5279C3.12919 4.07968 4.38194 3.65086 6.88743 2.79322L7.36477 2.62983C8.67082 2.18276 9.32384 1.95923 10 1.95923C10.6762 1.95923 11.3292 2.18276 12.6352 2.62983L13.1126 2.79322C15.6181 3.65086 16.8708 4.07968 17.1854 4.5279C17.5 4.97613 17.5 6.30845 17.5 8.97311C17.5 9.3756 17.5 9.81207 17.5 10.2854C17.5 14.9838 13.9675 17.2638 11.7512 18.232C11.15 18.4946 10.8494 18.6259 10 18.6259C9.15062 18.6259 8.85001 18.4946 8.2488 18.232C6.03247 17.2638 2.5 14.9838 2.5 10.2854C2.5 9.81207 2.5 9.3756 2.5 8.97311Z"
        stroke="CurrentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12.5 10.2926L10 10.2926M10 10.2926L7.5 10.2926M10 10.2926L10 7.7926M10 10.2926L10 12.7926"
        stroke="CurrentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Support = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 14.4593V10.2926C17.5 6.15047 14.1421 2.7926 10 2.7926C5.85786 2.7926 2.5 6.15047 2.5 10.2926V14.4593"
        stroke="#BDBDBD"
        stroke-width="1.5"
      />
      <path
        d="M18.3333 13.2092V14.8759"
        stroke="#BDBDBD"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M1.66675 13.2092V14.8759"
        stroke="#BDBDBD"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M6.66667 11.8298C6.66667 11.1928 6.66667 10.8743 6.52105 10.6528C6.44778 10.5414 6.35051 10.4493 6.237 10.3839C6.01143 10.2539 5.70677 10.2839 5.09745 10.344C4.07073 10.4452 3.55736 10.4958 3.18948 10.773C3.00329 10.9132 2.84698 11.092 2.73038 11.2982C2.5 11.7055 2.5 12.2422 2.5 13.3156V14.6203C2.5 15.683 2.5 16.2144 2.73498 16.6247C2.82293 16.7783 2.93317 16.9168 3.0618 17.0354C3.40544 17.3521 3.90703 17.451 4.91023 17.6488C5.6162 17.788 5.96918 17.8576 6.2297 17.711C6.32583 17.6569 6.4108 17.5837 6.47977 17.4954C6.66667 17.2563 6.66667 16.8824 6.66667 16.1346V11.8298Z"
        stroke="#BDBDBD"
        stroke-width="1.5"
      />
      <path
        d="M13.3333 11.8298C13.3333 11.1928 13.3333 10.8743 13.4789 10.6528C13.5521 10.5414 13.6494 10.4493 13.7629 10.3839C13.9885 10.2539 14.2932 10.2839 14.9025 10.344C15.9292 10.4452 16.4426 10.4958 16.8104 10.773C16.9966 10.9132 17.1529 11.092 17.2695 11.2982C17.4999 11.7055 17.4999 12.2422 17.4999 13.3156V14.6203C17.4999 15.683 17.4999 16.2144 17.2649 16.6247C17.177 16.7783 17.0667 16.9169 16.9381 17.0354C16.5945 17.3521 16.0929 17.451 15.0897 17.6488C14.3837 17.788 14.0307 17.8576 13.7702 17.711C13.6741 17.6569 13.5891 17.5837 13.5202 17.4954C13.3333 17.2563 13.3333 16.8824 13.3333 16.1346V11.8298Z"
        stroke="#BDBDBD"
        stroke-width="1.5"
      />
    </svg>
  );
};

export const HomeIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8253 19.2506H5.17533C2.89199 19.2506 1.04199 17.3923 1.04199 15.109V8.93396C1.04199 7.80063 1.74199 6.37563 2.64199 5.67563L7.13366 2.17563C8.48366 1.12563 10.642 1.07563 12.042 2.05896L17.192 5.6673C18.1837 6.35896 18.9587 7.8423 18.9587 9.05063V15.1173C18.9587 17.3923 17.1087 19.2506 14.8253 19.2506ZM7.90033 3.15896L3.40866 6.65896C2.81699 7.12563 2.29199 8.18396 2.29199 8.93396V15.109C2.29199 16.7006 3.58366 18.0006 5.17533 18.0006H14.8253C16.417 18.0006 17.7087 16.709 17.7087 15.1173V9.05063C17.7087 8.25063 17.1337 7.1423 16.4753 6.6923L11.3253 3.08396C10.3753 2.4173 8.80866 2.45063 7.90033 3.15896Z"
        fill="currentColor"
      />
      <path
        d="M10 15.9175C9.65833 15.9175 9.375 15.6341 9.375 15.2925V12.7925C9.375 12.4508 9.65833 12.1675 10 12.1675C10.3417 12.1675 10.625 12.4508 10.625 12.7925V15.2925C10.625 15.6341 10.3417 15.9175 10 15.9175Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const EmploymentIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0003 14.4591V16.4425C10.0003 18.0008 9.37533 18.6258 7.80866 18.6258H3.85033C2.29199 18.6258 1.66699 18.0008 1.66699 16.4425V12.4841C1.66699 10.9175 2.29199 10.2925 3.85033 10.2925H5.83366V12.2675C5.83366 13.8341 6.45866 14.4591 8.01699 14.4591H10.0003Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1663 10.2926V12.2676C14.1663 13.8343 13.5413 14.4593 11.9747 14.4593H8.01634C6.45801 14.4593 5.83301 13.8343 5.83301 12.2676V8.30931C5.83301 6.75098 6.45801 6.12598 8.01634 6.12598H9.99967V8.10098C9.99967 9.66764 10.6247 10.2926 12.183 10.2926H14.1663Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 4.14232V8.10065C18.3333 9.66732 17.7083 10.2923 16.1417 10.2923H12.1833C10.625 10.2923 10 9.66732 10 8.10065V4.14232C10 2.58398 10.625 1.95898 12.1833 1.95898H16.1417C17.7083 1.95898 18.3333 2.58398 18.3333 4.14232Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SubscriptionIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.50879 9.64258V13.3842C2.50879 17.1259 4.00879 18.6259 7.75046 18.6259H12.2421C15.9838 18.6259 17.4838 17.1259 17.4838 13.3842V9.64258"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99975 10.2923C11.5247 10.2923 12.6497 9.05065 12.4997 7.52565L11.9497 1.95898H8.05808L7.49975 7.52565C7.34975 9.05065 8.47475 10.2923 9.99975 10.2923Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2587 10.2923C16.942 10.2923 18.1753 8.92565 18.0087 7.25065L17.7753 4.95898C17.4753 2.79232 16.642 1.95898 14.4587 1.95898H11.917L12.5003 7.80065C12.642 9.17565 13.8837 10.2923 15.2587 10.2923Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.69966 10.2923C6.07466 10.2923 7.31632 9.17565 7.44966 7.80065L7.63299 5.95898L8.03299 1.95898H5.49133C3.30799 1.95898 2.47466 2.79232 2.17466 4.95898L1.94966 7.25065C1.78299 8.92565 3.01632 10.2923 4.69966 10.2923Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0003 14.459C8.60866 14.459 7.91699 15.1507 7.91699 16.5423V18.6257H12.0837V16.5423C12.0837 15.1507 11.392 14.459 10.0003 14.459Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ProfileIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1331 9.35065C10.0498 9.34232 9.9498 9.34232 9.85814 9.35065C7.8748 9.28398 6.2998 7.65898 6.2998 5.65898C6.2998 3.61732 7.9498 1.95898 9.9998 1.95898C12.0415 1.95898 13.6998 3.61732 13.6998 5.65898C13.6915 7.65898 12.1165 9.28398 10.1331 9.35065Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.9666 12.426C3.94993 13.776 3.94993 15.976 5.9666 17.3176C8.25827 18.851 12.0166 18.851 14.3083 17.3176C16.3249 15.9676 16.3249 13.7676 14.3083 12.426C12.0249 10.901 8.2666 10.901 5.9666 12.426Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NotificationIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.953 10.8867C13.7663 11.3867 13.373 11.7667 12.8597 11.94C12.1397 12.18 11.3997 12.36 10.653 12.4867C10.5797 12.5 10.5063 12.5134 10.433 12.52C10.313 12.54 10.193 12.5534 10.073 12.5667C9.92633 12.5867 9.773 12.6 9.61967 12.6134C9.19967 12.6467 8.78633 12.6667 8.36633 12.6667C7.93967 12.6667 7.513 12.6467 7.093 12.6067C6.913 12.5934 6.73967 12.5734 6.56633 12.5467C6.46633 12.5334 6.36633 12.52 6.273 12.5067C6.19967 12.4934 6.12633 12.4867 6.053 12.4734C5.313 12.3534 4.57967 12.1734 3.86633 11.9334C3.333 11.7534 2.92633 11.3734 2.74633 10.8867C2.56633 10.4067 2.633 9.8467 2.91967 9.3667L3.673 8.11337C3.833 7.84003 3.97967 7.31337 3.97967 6.99337V5.75337C3.97967 3.33337 5.94633 1.3667 8.36633 1.3667C10.7797 1.3667 12.7463 3.33337 12.7463 5.75337V6.99337C12.7463 7.31337 12.893 7.84003 13.0597 8.11337L13.813 9.3667C14.0863 9.83337 14.1397 10.38 13.953 10.8867Z"
        fill="#284CB1"
      />
      <path
        d="M8.35286 7.17326C8.07286 7.17326 7.84619 6.94659 7.84619 6.66659V4.59993C7.84619 4.31993 8.07286 4.09326 8.35286 4.09326C8.63286 4.09326 8.85953 4.31993 8.85953 4.59993V6.66659C8.85286 6.94659 8.62619 7.17326 8.35286 7.17326Z"
        fill="white"
      />
      <path
        d="M10.2398 13.3402C9.95981 14.1135 9.21981 14.6668 8.35314 14.6668C7.82648 14.6668 7.30648 14.4535 6.93981 14.0735C6.72648 13.8735 6.56648 13.6068 6.47314 13.3335C6.55981 13.3468 6.64648 13.3535 6.73981 13.3668C6.89314 13.3868 7.05314 13.4068 7.21314 13.4202C7.59314 13.4535 7.97981 13.4735 8.36648 13.4735C8.74648 13.4735 9.12648 13.4535 9.49981 13.4202C9.63981 13.4068 9.77981 13.4002 9.91314 13.3802C10.0198 13.3668 10.1265 13.3535 10.2398 13.3402Z"
        fill="#284CB1"
      />
    </svg>
  );
};

export const UsersIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#D9D6FF" fillOpacity="0.5" />
      <path
        d="M20.6769 14.5229C18.0972 14.5229 16 16.6202 16 19.1999C16 21.7303 17.9791 23.7783 20.5588 23.8669C20.6375 23.8571 20.7163 23.8571 20.7754 23.8669C20.7951 23.8669 20.8049 23.8669 20.8246 23.8669C20.8345 23.8669 20.8345 23.8669 20.8443 23.8669C23.3649 23.7783 25.344 21.7303 25.3538 19.1999C25.3538 16.6202 23.2566 14.5229 20.6769 14.5229Z"
        fill="#284CB1"
      />
      <path
        d="M25.6787 26.4858C22.9316 24.6545 18.4516 24.6545 15.6848 26.4858C14.4343 27.3228 13.7451 28.4551 13.7451 29.6662C13.7451 30.8772 14.4343 31.9997 15.675 32.8268C17.0534 33.7523 18.8651 34.2151 20.6768 34.2151C22.4885 34.2151 24.3002 33.7523 25.6787 32.8268C26.9193 31.9898 27.6085 30.8674 27.6085 29.6465C27.5987 28.4354 26.9193 27.3129 25.6787 26.4858Z"
        fill="#284CB1"
      />
      <path
        d="M31.4985 19.7808C31.6561 21.691 30.2973 23.3648 28.4167 23.5913C28.4068 23.5913 28.4068 23.5913 28.397 23.5913H28.3674C28.3084 23.5913 28.2493 23.5913 28.2001 23.6109C27.245 23.6602 26.3687 23.3549 25.709 22.7937C26.7231 21.8879 27.3041 20.5291 27.1859 19.0522C27.117 18.2546 26.8413 17.526 26.4278 16.9057C26.8019 16.7186 27.2351 16.6005 27.6782 16.5611C29.6081 16.3937 31.3311 17.8313 31.4985 19.7808Z"
        fill="#284CB1"
      />
      <path
        d="M33.4668 28.8888C33.388 29.8439 32.7775 30.6709 31.7535 31.2322C30.7689 31.7737 29.5283 32.0297 28.2975 32.0002C29.0065 31.3602 29.42 30.5626 29.4988 29.7159C29.5972 28.4949 29.0163 27.3233 27.8545 26.3879C27.1948 25.866 26.4268 25.4525 25.5898 25.1473C27.7658 24.5171 30.5031 24.9405 32.1868 26.2993C33.0926 27.0279 33.5554 27.9436 33.4668 28.8888Z"
        fill="#284CB1"
      />
    </svg>
  );
};

export const Dot = () => {
  return (
    <svg
      width="18"
      height="5"
      viewBox="0 0 18 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 2.26367C4 3.36824 3.10457 4.26367 2 4.26367C0.89543 4.26367 0 3.36824 0 2.26367C0 1.1591 0.89543 0.263672 2 0.263672C3.10457 0.263672 4 1.1591 4 2.26367Z"
        fill="#284CB1"
      />
      <path
        d="M11 2.26367C11 3.36824 10.1046 4.26367 9 4.26367C7.89543 4.26367 7 3.36824 7 2.26367C7 1.1591 7.89543 0.263672 9 0.263672C10.1046 0.263672 11 1.1591 11 2.26367Z"
        fill="#284CB1"
      />
      <path
        d="M18 2.26367C18 3.36824 17.1046 4.26367 16 4.26367C14.8954 4.26367 14 3.36824 14 2.26367C14 1.1591 14.8954 0.263672 16 0.263672C17.1046 0.263672 18 1.1591 18 2.26367Z"
        fill="#284CB1"
      />
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 1H4C2.58579 1 1.87868 1 1.43934 1.4122C1 1.8244 1 2.48782 1 3.81466V4.50448C1 5.54232 1 6.06124 1.2596 6.49142C1.5192 6.9216 1.99347 7.18858 2.94202 7.72255L5.85504 9.36238C6.49146 9.72064 6.80967 9.89977 7.03751 10.0976C7.51199 10.5095 7.80408 10.9935 7.93644 11.5872C8 11.8722 8 12.2058 8 12.8729L8 15.5424C8 16.452 8 16.9067 8.25192 17.2613C8.50385 17.6158 8.95128 17.7907 9.84615 18.1406C11.7248 18.875 12.6641 19.2422 13.3321 18.8244C14 18.4066 14 17.4519 14 15.5424V12.8729C14 12.2058 14 11.8722 14.0636 11.5872C14.1959 10.9935 14.488 10.5095 14.9625 10.0976C15.1903 9.89977 15.5085 9.72064 16.145 9.36238L19.058 7.72255C20.0065 7.18858 20.4808 6.9216 20.7404 6.49142C21 6.06124 21 5.54232 21 4.50448V3.81466C21 2.48782 21 1.8244 20.5607 1.4122C20.1213 1 19.4142 1 18 1Z"
        stroke="#1C274C"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const SettingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.6em"
      height="1.6em"
      viewBox="-2 -4 24 24"
    >
      <path
        fill="currentColor"
        d="M9 12V1a1 1 0 1 1 2 0v11h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0v-1H8a1 1 0 0 1 0-2zm7-10V1a1 1 0 0 1 2 0v1h1a1 1 0 0 1 0 2h-1v11a1 1 0 0 1-2 0V4h-1a1 1 0 0 1 0-2zM4 5h1a1 1 0 1 1 0 2H4v8a1 1 0 0 1-2 0V7H1a1 1 0 1 1 0-2h1V1a1 1 0 1 1 2 0z"
      ></path>
    </svg>
  );
};

export const HospitalBadge = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#D9D6FF" fillOpacity="0.5" />
      <path
        d="M16.5 22.6806C16.5 20.0159 16.5 18.6836 16.8146 18.2354C17.1292 17.7871 18.3819 17.3583 20.8874 16.5007L21.3648 16.3373C22.6708 15.8902 23.3238 15.6667 24 15.6667C24.6762 15.6667 25.3292 15.8902 26.6352 16.3373L27.1126 16.5007C29.6181 17.3583 30.8708 17.7871 31.1854 18.2354C31.5 18.6836 31.5 20.0159 31.5 22.6806C31.5 23.0831 31.5 23.5195 31.5 23.9928C31.5 28.6912 27.9675 30.9713 25.7512 31.9394C25.15 32.202 24.8494 32.3334 24 32.3334C23.1506 32.3334 22.85 32.202 22.2488 31.9394C20.0325 30.9713 16.5 28.6912 16.5 23.9928C16.5 23.5195 16.5 23.0831 16.5 22.6806Z"
        stroke="#284CB1"
        strokeWidth="1.5"
      />
      <path
        d="M26.5 24L24 24M24 24L21.5 24M24 24L24 21.5M24 24L24 26.5"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const BagIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66699 11.9596C1.66699 8.81694 1.66699 7.24559 2.6433 6.26928C3.61961 5.29297 5.19096 5.29297 8.33366 5.29297H11.667C14.8097 5.29297 16.381 5.29297 17.3573 6.26928C18.3337 7.24559 18.3337 8.81694 18.3337 11.9596C18.3337 15.1023 18.3337 16.6737 17.3573 17.65C16.381 18.6263 14.8097 18.6263 11.667 18.6263H8.33366C5.19096 18.6263 3.61961 18.6263 2.6433 17.65C1.66699 16.6737 1.66699 15.1023 1.66699 11.9596Z"
        stroke="CurrentColor"
        strokeWidth="1.5"
      />
      <path
        d="M18.0511 7.55957C15.5429 9.1899 14.2888 10.0051 12.9667 10.4158C11.0342 11.0162 8.96509 11.0162 7.03262 10.4158C5.71054 10.0051 4.45644 9.1899 1.94824 7.55957"
        stroke="CurrentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6.66699 9.45996V11.1266"
        stroke="CurrentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M13.333 9.45996V11.1266"
        stroke="CurrentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7.64258 3.62663C7.98578 2.65563 8.91181 1.95996 10.0003 1.95996C11.0888 1.95996 12.0149 2.65563 12.3581 3.62663"
        stroke="CurrentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ScheduleIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.94812 1.33398H10.0522C11.7303 1.33397 13.0546 1.33396 14.0193 1.46115C14.9674 1.58615 15.8193 1.86164 16.2239 2.6472C16.2822 2.76038 16.3314 2.87799 16.371 2.99894C16.6471 3.84142 16.2386 4.63721 15.6567 5.39039C15.065 6.15635 14.1281 7.08408 12.942 8.25863L10.8884 10.2923L12.942 12.326C14.1281 13.5006 15.065 14.4283 15.6567 15.1942C16.2386 15.9474 16.6471 16.7432 16.371 17.5857C16.3314 17.7066 16.2822 17.8243 16.2239 17.9374C15.8193 18.723 14.9674 18.9985 14.0193 19.1235C13.0546 19.2507 11.7303 19.2507 10.0521 19.2507H9.94814C8.27003 19.2507 6.94564 19.2507 5.981 19.1235C5.03287 18.9985 4.18097 18.723 3.77638 17.9374C3.71809 17.8243 3.66889 17.7066 3.62925 17.5857C3.3532 16.7432 3.76172 15.9474 4.34357 15.1942C4.93528 14.4283 5.87213 13.5006 7.05824 12.326L9.1119 10.2923L7.05824 8.25863C5.87213 7.08408 4.93528 6.15635 4.34357 5.39039C3.76172 4.63721 3.3532 3.84142 3.62925 2.99895C3.66889 2.87799 3.71809 2.76038 3.77638 2.6472C4.18097 1.86164 5.03287 1.58615 5.981 1.46115C6.94563 1.33396 8.27002 1.33397 9.94812 1.33398ZM10.0001 9.41272L12.0251 7.40744C13.2567 6.18782 14.1329 5.31819 14.6675 4.62621C15.2181 3.91344 15.248 3.58609 15.1832 3.38817C15.1642 3.33026 15.1406 3.27387 15.1126 3.21954C15.0154 3.03072 14.7553 2.81901 13.8559 2.70042C12.9829 2.58532 11.7415 2.58398 10.0001 2.58398C8.25873 2.58398 7.01737 2.58532 6.1444 2.70042C5.24497 2.81901 4.9849 3.03072 4.88765 3.21954C4.85967 3.27387 4.83609 3.33026 4.81711 3.38817C4.75226 3.58609 4.78214 3.91344 5.33277 4.62621C5.86734 5.31819 6.74357 6.18782 7.97517 7.40745L10.0001 9.41272ZM10.0001 11.1719L7.97517 13.1772C6.74356 14.3968 5.86734 15.2664 5.33277 15.9584C4.78214 16.6712 4.75226 16.9985 4.81711 17.1965C4.83609 17.2544 4.85967 17.3108 4.88765 17.3651C4.9849 17.5539 5.24497 17.7656 6.1444 17.8842C7.01737 17.9993 8.25873 18.0007 10.0001 18.0007C11.7415 18.0007 12.9829 17.9993 13.8559 17.8842C14.7553 17.7656 15.0154 17.5539 15.1126 17.3651C15.1406 17.3108 15.1642 17.2544 15.1832 17.1965C15.248 16.9985 15.2181 16.6712 14.6675 15.9584C14.1329 15.2664 13.2567 14.3968 12.0251 13.1772L10.0001 11.1719ZM7.70847 4.87565C7.70847 4.53047 7.98829 4.25065 8.33347 4.25065H11.6668C12.012 4.25065 12.2918 4.53047 12.2918 4.87565C12.2918 5.22083 12.012 5.50065 11.6668 5.50065H8.33347C7.98829 5.50065 7.70847 5.22083 7.70847 4.87565ZM7.70847 15.709C7.70847 15.3638 7.98829 15.084 8.33347 15.084H11.6668C12.012 15.084 12.2918 15.3638 12.2918 15.709C12.2918 16.0542 12.012 16.334 11.6668 16.334H8.33347C7.98829 16.334 7.70847 16.0542 7.70847 15.709Z"
        fill="CurrentColor"
      />
    </svg>
  );
};
export const MessageIconCover = () => {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24.6666" cy="24" r="24" fill="#D9D6FF" fillOpacity="0.5" />
      <path
        d="M16.3333 25.6667C16.3333 22.524 16.3333 20.9526 17.3096 19.9763C18.2859 19 19.8572 19 22.9999 19H26.3333C29.4759 19 31.0473 19 32.0236 19.9763C32.9999 20.9526 32.9999 22.524 32.9999 25.6667C32.9999 28.8094 32.9999 30.3807 32.0236 31.357C31.0473 32.3333 29.4759 32.3333 26.3333 32.3333H22.9999C19.8572 32.3333 18.2859 32.3333 17.3096 31.357C16.3333 30.3807 16.3333 28.8094 16.3333 25.6667Z"
        stroke="#284CB1"
        strokeWidth="1.5"
      />
      <path
        d="M32.7181 21.2666C30.2099 22.8969 28.9558 23.7121 27.6337 24.1229C25.7012 24.7233 23.6321 24.7233 21.6996 24.1229C20.3775 23.7121 19.1234 22.8969 16.6152 21.2666"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M21.3333 23.167V24.8337"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M28 23.167V24.8337"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M22.3088 17.3337C22.652 16.3627 23.5781 15.667 24.6666 15.667C25.7551 15.667 26.6811 16.3627 27.0243 17.3337"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const SubscriptionIconLarge = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#D9D6FF" fillOpacity="0.5" />
      <path
        d="M16.5083 23.3496V27.0913C16.5083 30.8329 18.0083 32.3329 21.75 32.3329H26.2416C29.9833 32.3329 31.4833 30.8329 31.4833 27.0913V23.3496"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 24.0003C25.525 24.0003 26.65 22.7587 26.5 21.2337L25.95 15.667H22.0583L21.5 21.2337C21.35 22.7587 22.475 24.0003 24 24.0003Z"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.2584 24.0003C30.9417 24.0003 32.1751 22.6337 32.0084 20.9587L31.7751 18.667C31.4751 16.5003 30.6417 15.667 28.4584 15.667H25.9167L26.5001 21.5087C26.6417 22.8837 27.8834 24.0003 29.2584 24.0003Z"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6999 24.0003C20.0749 24.0003 21.3166 22.8837 21.4499 21.5087L21.6332 19.667L22.0332 15.667H19.4916C17.3082 15.667 16.4749 16.5003 16.1749 18.667L15.9499 20.9587C15.7832 22.6337 17.0166 24.0003 18.6999 24.0003Z"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0001 28.167C22.6084 28.167 21.9167 28.8587 21.9167 30.2503V32.3337H26.0834V30.2503C26.0834 28.8587 25.3917 28.167 24.0001 28.167Z"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
